import {Disposable, Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {PublishReportInput, PublishReportMutation} from './__generated__/PublishReportMutation.graphql';

const mutation = graphql`
	mutation PublishReportMutation($input: PublishReportInput!) {
		publishReport(input: $input) {
			draftState
			publishedAt
			locked
			draftFilterWillRevert
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<PublishReportInput>,
	onSuccess?: RelayOnCompleted<PublishReportMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
